import React from "react";
import { Button } from "react-bootstrap";

import "../styles.css";

const FilterButton = ({ data, handleChange, type }) => {
  return (
    <Button
      id={`button-${type}`}
      variant="outline-secondary"
      className="btn-filter"
      active={data?.active}
      value={data?.value}
      onClick={handleChange}
    >
      {data?.text} ({data?.count})
    </Button>
  );
};

export default FilterButton;
